import script from "./SignupPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignupPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignupPage.vue?vue&type=style&index=0&id=756c9699&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-756c9699"]])

export default __exports__